export const uuidRegexString = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
export const numbersAndLettersRegexString = "^(?=.*[a-zA-Z])(?=.*[0-9])";
